<template>
<div>
  <nav id="mobile-navigation" class="top-navigation" role="navigation">
      <div class="header-menu">
          <ul id="menu-main" class="menu">
              <li id="menu-item-259" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-217 current_page_item menu-item-259"><a href="/">Home</a>
              </li>
              <li id="menu-item-19" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-19"><a href="/about">About</a>
              </li>
              <li id="menu-item-733" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-733"><a href="/instructions">Instructions</a>
              </li>
              <li id="menu-item-18" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-18"><a href="/contact">Contact</a>
              </li>
          </ul>
      </div>
  </nav>
  <div id="page" class="hfeed site">
      <a class="skip-link screen-reader-text" href="#content">Skip to content</a>
      <!-- <a class="menu-open dashicons dashicons-menu" href="#mobile-navigation"></a> -->
      <router-link class="menu-open dashicons dashicons-menu" to="/#mobile-navigation"></router-link>
      <a class="menu-close dashicons dashicons-no" href="#"></a>
  <!-- #site-navigation -->
      <header id="masthead" class="site-header no-header-image" role="banner">
          <div id="site-banner" class="cf social logo is-right">
              <div id="site-banner-left" class="is-right">
                  <div class="site-branding">
                      <h1 class="site-logo"><a href="/" rel="home"><img :src="logo" alt="logo" /></a></h1>
                  </div>
                  <!-- .site-branding -->
                  <nav id="site-navigation" class="main-navigation top-navigation" role="navigation">
                      <div class="header-menu">
                          <ul id="menu-main-1" class="menu">
                              <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-217 current_page_item menu-item-259"><a href="/">Home</a>
                              </li>
                              <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-19"><a href="/about">About</a>
                              </li>
                              <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-733"><a href="/instructions">Instructions</a>
                              </li>
                              <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-18"><a href="/contact">Contact</a>
                              </li>
                          </ul>
                      </div>
                  </nav>
                  <!-- #site-navigation -->
              </div>
              <div id="site-banner-right">
                  <ul class="hr-social">
                      <li v-if="facebookIcon">
                          <a title="Follow Us on Facebook" :href="['https://www.facebook.com']" target="_blank">
                              <img :src="[facebookIcon]" width="24" height="24" alt="Facebook icon" />
                          </a>
                      </li>
                      <li v-if="instagramIcon">
                          <a title="Follow Us on Instagram" :href="['https://www.Instagram.com']" target="_blank">
                              <img :src="[instagramIcon]" width="24" height="24" alt="Instagram icon" />
                          </a>
                      </li>
                      <li v-if="twitterIcon">
                          <a title="Follow Us on Twitter" :href="['https://www.twitter.com']" target="_blank">
                              <img :src="[twitterIcon]" width="24" height="24" alt="Twitter icon" />
                          </a>
                      </li>
                  </ul>
              </div>
          </div>
      </header>
  </div>
</div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.site-header a, .main-navigation ul ul a, .menu-open, .dashicons.menu-open, .menu-close, .dashicons.menu-close {
  color: #000000;
}
</style>
<style>
    .site-header,
    .main-navigation ul ul a {
        background-color: rgb(255, 255, 255);
    }
    .home .site-header,
    .home .main-navigation ul ul a {
        background-color: rgba(255, 255, 255, 1);
    }
    .site-header,
    .site-header h1,
    .site-header h2,
    .site-header h3,
    .site-header h4,
    .site-header h5,
    .site-header h6 {
        color: #000000;
    }
    .site-header a,
    .main-navigation ul ul a,
    .menu-open,
    .dashicons.menu-open,
    .menu-close,
    .dashicons.menu-close {
        color: #000000;
    }
    .site-header a:hover,
    .main-navigation ul ul a:hover,
    .menu-open:hover,
    .dashicons.menu-open:hover,
    .menu-close:hover,
    .dashicons.menu-open:hover {
        color: #089afc;
    }
    /*
You can add your own CSS here.
Click the help icon above to learn more.
*/
    .textwidget p {
        padding-bottom: 0px !important;
    }
    .textwidget h2 {
        margin-bottom: 20px !important
    }
</style>
<style id="tt-easy-google-font-styles" type="text/css">
    p {
        color: #000000;
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 300;
    }
    h1 {} h2 {} h3 {} h4 {} h5 {} h6 {} .about-headline {
        color: #000000;
        font-family: 'Roboto';
        font-size: 30px;
        font-style: normal;
        font-weight: 300;
        line-height: 0.8;
        margin-top: 21px;
        margin-right: 400px;
        padding-right: 400px;
    }
    .contact-headline {
        color: #ab0c6f;
        font-family: 'Roboto';
        font-size: 25px;
        font-style: normal;
        font-weight: 400;
        padding-top: 30px;
    }
    .home-headline {
        color: #ab0c6f;
        font-family: 'Roboto';
        font-size: 29px;
        font-style: normal;
        font-weight: 400;
        line-height: 1.4;
    }
    .home-subline {
        color: #ab0c6f;
        font-family: 'Roboto';
        font-size: 25px;
        font-style: normal;
        font-weight: 300;
    }
</style>
<script type="text/javascript">
    export default {
        props: ["logo", "facebookIcon", "instagramIcon", "twitterIcon"],
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Header.vue